import { type Tag } from '@app/client';

import { ACTION_SET_CURRENT_EMOJI_TAGS, type UserEmojiActionTypes } from '../types/user-emojis';

// TODO: This was pulled out of `src/store/actions/user-emojis.ts` because
// of a circular dependency between:
// user-emojis.ts > emoji.ts > yat-page.ts
export const setCurrentEmojiTags = (tags: Tag[]): UserEmojiActionTypes => ({
    type: ACTION_SET_CURRENT_EMOJI_TAGS,
    tags,
});
